import ApiService from "../../ApiService";

const AssignmentPreviewService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/spokenbooks/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    loadSections: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/spokenbooks/loadsections", vo, successCallback, failureCallback);
    },
    loadUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/chinesepark/spokenbooks/loadunits", vo, successCallback, failureCallback);
    },
};

export default AssignmentPreviewService;
